import React from 'react';
import AdditionalInfo from '../../components/additionalInfo';

export default function StepFour() {
  return (
    <AdditionalInfo />
  );
}